import { LANGUAGES } from '@domain/language';

export const getLanguageTranslationKey = (language: string) =>
  LANGUAGES.find((lang) => lang.id === language)?.value ?? 'common:languageEnglish';
